module.exports = __webpack_public_path__ + "assets/img/16@3x.84303c6b.png";